import { all, call, put, takeLatest } from 'redux-saga/effects';
import { GET_LIST_DANHSACHKHO } from 'actions/DanhSachKho/actionTypes';
import {
  getListDanhSachKhoSuccess,
  getListDanhSachKhoFailure,
} from 'actions/DanhSachKho';
import { pushNotification } from 'utils/notifications';
import StoreApi from 'service/storeApi';

function* getListDanhSachKho(action) {
  try {
    const response = yield call(StoreApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachKhoSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getListDanhSachKhoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getListDanhSachKhoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHKHO, getListDanhSachKho);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
